import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import { CwfDocumentTypesError, CwfDocumentTypesResponse } from '@/api/model';

const KEY = {
  GET_DOCUMENT_TYPES: 'GET_DOCUMENT_TYPES',
} as const;

const request = {
  getDocumentTypes: async (signal?: AbortSignal) => {
    const { data } = await fetchClient.FCT.get<CwfDocumentTypesResponse>(
      ENDPOINTS.FCT.CWF.DOCUMENT_TYPES.BASE,
      {
        signal,
      },
    );

    return data;
  },
};

const query = {
  useGetDocumentTypes: (
    config?: Partial<UseQueryOptions<CwfDocumentTypesResponse, CwfDocumentTypesError>>,
  ) =>
    useQuery<CwfDocumentTypesResponse, CwfDocumentTypesError>({
      queryFn: ({ signal }) => request.getDocumentTypes(signal),
      queryKey: [KEY.GET_DOCUMENT_TYPES],
      ...config,
    }),
};

export const documentTypes = {
  KEY,
  query,
  request,
};
